module.exports = __webpack_public_path__ + "static/media/SF-6-A.536cd92b.mp3";